/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ViridisChem API
 * API documentation for ViridisChem API
 */

export type FeatureOption = (typeof FeatureOption)[keyof typeof FeatureOption];

export const FeatureOption = {
    ALL_FEATURES: "ALL_FEATURES",
    ApplicationServer: "ApplicationServer",
    ApplicationAll: "ApplicationAll",
    AdminToken: "AdminToken",
    Agent: "Agent",
    ChemicalSearch: "ChemicalSearch",
    ChemicalEstimation: "ChemicalEstimation",
    ChemicalEstimationDisableCache: "ChemicalEstimationDisableCache",
    ChemicalSearchEstimationDispatch: "ChemicalSearchEstimationDispatch",
    ChemicalAdvancedSearch: "ChemicalAdvancedSearch",
    SubstanceSearch: "SubstanceSearch",
    ChemicalPricing: "ChemicalPricing",
    ChemPredictorPrediction: "ChemPredictorPrediction",
    Library: "Library",
    Notebook: "Notebook",
    FormulationAnalysis: "FormulationAnalysis",
    ReactionAnalysis: "ReactionAnalysis",
    ReactionSynthesis: "ReactionSynthesis",
    ReagentGuide: "ReagentGuide",
    SolventGuide: "SolventGuide",
    ApiAccess: "ApiAccess",
    RemoteAccess: "RemoteAccess",
    Daikin: "Daikin",
    ShowSubproperties: "ShowSubproperties",
    ViridisChemDataManagement: "ViridisChemDataManagement",
    ViridisChemAdmin: "ViridisChemAdmin",
    StructureDrawingKetcher: "StructureDrawingKetcher",
    StructureDrawingMarvinJs: "StructureDrawingMarvinJs",
    SDSBuilder: "SDSBuilder",
    SDSViewer: "SDSViewer",
    ChemAxonApi: "ChemAxonApi",
    NMRium: "NMRium",
} as const;
